"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var breakpoints_1 = require("../style/breakpoints");
var Spacer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex-shrink: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  flex-shrink: ", ";\n  ",
    "\n  ", "\n  ", "\n  ", "\n"])), function (props) { return Number(Boolean(props.shrink)); }, function (props) {
    return props.shrink
        ? "\n  min-height: 0;\n  min-width: 0;"
        : "";
}, function (props) { return (props.inline ? "display: inline-block;" : ""); }, function (props) { return (props.width ? breakpoints_1.bp.each("width", props.width, "px") : ""); }, function (props) { return (props.height ? breakpoints_1.bp.each("height", props.height, "px") : ""); });
exports.default = Spacer;
var templateObject_1;
